import { getCDNPath } from './getCDNpath'

// URL аватара: пресетные аватары хранятся строкой пути, загруженные — объектом вложения { image }
export const getAvatarUrl = (avatar) => {
	if (typeof avatar === 'string') return avatar
	if (avatar?.image) return getCDNPath(avatar.image)
	return getCDNPath('images/default_avatar.png')
}
